export interface SystemSetting {
    id?: string;
    name: string;
    value: string;
}

export enum SystemSettingsEnum {
    OfflineModeEnabled = 'OfflineModeEnabled',
    OfflineModeExcludedUsers = 'Sales.OfflineModeExcludedUsers',
    HideSubTotal = 'HideSubTotal',
    SystemStartDate = 'FixedAssets.SystemStartDate',
    FinancialYearEndDate = "FixedAssets.FinancialYearEndDate",
    AllowSellingBySerialNumber = "Sales.AllowSellingBySerialNumber",
    CheckSerialOwner = "Sales.CheckSerialOwner",
    CheckSerialAvailability = "Sales.CheckSerialAvailability",
    CheckSerialFulfillment = "Sales.CheckSerialFulfillment",
    InventoryManagementMethod = "Warehouse.InventoryManagementMethod",
    HideBalanceAndBatchDetails = "Sales.HideBalanceAndBatchDetails",
    UiControlToFocusOnAfterAddingItem = "Sales.UiControlToFocusOnAfterAddingItem",
    PrioritizesScanningBarcode = "Sales.PrioritizesScanningBarcode",
    PreventSellingZeroBalanceStockItems = "Sales.PreventSellingZeroBalanceStockItems",
    HideCostOnProductionOrderPrint = "Manufacturing.HideCostOnProductionOrderPrint",
    OrderTakerUsers = "Sales.OrderTakerUsers",
    UseCashOnDelivery = "Sales.UseCashOnDelivery",
    RealTimeStockItemBalanceUpdate = "Sales.RealTimeStockItemBalanceUpdate",
    SOLockSettings = "Sales.SOLockSettings",
    DefaultCurrency = "DefaultCurrency",
    // Settings V3
    IsEdara2IntegrationConnected = "IsEdara2IntegrationConnected",
    EdaraSetupCompleted = "EdaraSetupCompleted",
    Global = "Global",
    OrganizationProfile = "OrganizationProfile",
    Order = "Order",
    PurchaseInvoice = "PurchaseInvoice",
    SalesInvoice = "SalesInvoice",
    Product = "Product",
    EReceipt_EGP_Connected = "EReceipt_EGP_Connected",
    EReceipt_EGP_Paused = "EReceipt_EGP_Paused"
}


export enum UiControlToFocusOnAfterAddingItemEnum {
    SearchInput = 'SearchInput',
    ItemQuantity = 'ItemQuantity'
}

export enum PrioritizesScanningBarcodeEnum {
    normalOverWeighted = 1,
    weightedOverNormal = 2
}

export enum ParentModuleEnum {
    PointOfSale = 'PointOfSale',
    Invoicing = 'Invoicing',
    Purchasing = 'Purchasing',
    FixedAssets = 'FixedAssets',
    Manufacturing = 'Manufacturing'
}

export interface SOLockSettings {
    isLockEnabled: boolean;
    lockType: SOLockTypes;
    printTemplates: number[];
    automaticActions: SOLockAutomaticActions;
}

export enum SOLockTypes {
    NoAuto = 'NoAuto',
    AutoOnCreate = 'AutoOnCreate',
    AutoOnPrint = 'AutoOnPrint',
    AutoOnSpecificPrintTemplates = 'AutoOnSpecificPrintTemplates',
}

export enum SOLockAutomaticActions {
    NoAutomaticActions = 'NoAutomaticActions',
    AutoApprove = 'AutoApprove',
    AutoApproveAndIssue = 'AutoApproveAndIssue'
}

/**
 * Outcome of an attempt to lock a sales order.
 *
 * Locking is only meaningful for orders that already exist offline (Order 2.5). Automatic
 * approve/issue must follow the *transition* into the locked state, never the mere fact that
 * an order currently is locked - otherwise printing, editing or re-syncing a locked order
 * would replay a business action that already happened.
 */
export enum SOLockOutcome {
    /** The order moved from unlocked to locked as a result of this operation. */
    Locked = 'Locked',
    /** The order was already locked; no transition occurred and no automatic action is due. */
    AlreadyLocked = 'AlreadyLocked',
    /** The order has no offline document, so it is not part of the lock lifecycle. */
    NotEligible = 'NotEligible'
}

export interface SOLockResult {
    outcome: SOLockOutcome;
    /** Id of the offline document that carries the lock state, when the order is eligible. */
    externalId?: string;
}
